var $;

$ = (typeof window !== "undefined" ? window['$'] : typeof global !== "undefined" ? global['$'] : null);

module.exports = function() {
  var $spnav, $spnbt, $spnco, disableSPNav, enableSPNav;
  $spnav = $("#spnav");
  $spnbt = $spnav.children("#spnav-button");
  $spnco = $spnav.children("#spnav-container");
  enableSPNav = function() {
    return $spnco.removeClass("offscreen");
  };
  disableSPNav = function() {
    return $spnco.addClass("offscreen");
  };
  $(window).on("load", function() {
    $spnav.removeClass("collapse");
    return $spnbt.removeClass("collapse");
  });
  $spnbt.on("click", enableSPNav);
  $("#pagecatch, #pagemain, #pagefooter").on("click", disableSPNav);
  return $spnco.find("a[href^=#]").on("click", disableSPNav);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BuYXYuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcG5hdi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFFBQVI7O0FBRUosTUFBTSxDQUFDLE9BQVAsR0FBaUIsU0FBQTtBQUNoQixNQUFBO0VBQUEsTUFBQSxHQUFTLENBQUEsQ0FBRSxRQUFGO0VBQ1QsTUFBQSxHQUFTLE1BQU0sQ0FBQyxRQUFQLENBQWdCLGVBQWhCO0VBQ1QsTUFBQSxHQUFTLE1BQU0sQ0FBQyxRQUFQLENBQWdCLGtCQUFoQjtFQUVULFdBQUEsR0FBYyxTQUFBO1dBRWIsTUFBTSxDQUFDLFdBQVAsQ0FBbUIsV0FBbkI7RUFGYTtFQUlkLFlBQUEsR0FBZSxTQUFBO1dBRWQsTUFBTSxDQUFDLFFBQVAsQ0FBZ0IsV0FBaEI7RUFGYztFQUlmLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxFQUFWLENBQWEsTUFBYixFQUFxQixTQUFBO0lBQ3BCLE1BQU0sQ0FBQyxXQUFQLENBQW1CLFVBQW5CO1dBQ0EsTUFBTSxDQUFDLFdBQVAsQ0FBbUIsVUFBbkI7RUFGb0IsQ0FBckI7RUFJQSxNQUFNLENBQUMsRUFBUCxDQUFVLE9BQVYsRUFBbUIsV0FBbkI7RUFDQSxDQUFBLENBQUUsb0NBQUYsQ0FBdUMsQ0FBQyxFQUF4QyxDQUEyQyxPQUEzQyxFQUFvRCxZQUFwRDtTQUVBLE1BQU0sQ0FBQyxJQUFQLENBQVksWUFBWixDQUF5QixDQUFDLEVBQTFCLENBQTZCLE9BQTdCLEVBQXNDLFlBQXRDO0FBcEJnQiJ9
